<template>
  <!-- 通讯录 -->
  <div class="addressBook_index">
    <van-nav-bar
      :title="'通讯录'"
      left-text
      left-arrow
      @click-left="onClickLeft"
      
      :fixed="true"
    />
    <div class="content">
     
        <!-- <van-collapse-item title="身份信息" name="1">
          <van-cell-group :border="false">
            <van-cell :title="$t('reqrcode.qrTxt8')" :value="empinfo.empcode" />
            <van-cell :title="$t('reqrcode.qrTxt9')" :value="empinfo.empname" />
          </van-cell-group>
        </van-collapse-item> -->
        <div class="personTop"
          >
        <div class="personCont">
          <div class="presonAvar">
            <img style="border-radius: 100%"
                 :src="empinfo.cappicurl" />
          </div>
          <div class="presonInfo">
            <div class="personCon">
              <div class="personCon_child">
                <h2>{{ empinfo.empname }}</h2>
                <p>{{ empinfo.empcode }}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
       <van-collapse v-model="activeNames">
        <van-collapse-item title="联系信息" name="2">
          <van-cell-group>
            <van-cell
              v-for="e in fieldlist"
              :key="e.fieldname"
              :title="e.chnname"
              :value="fieldvalue[e.fieldname]"
            >
            <template v-if="e.fieldname=='mobilephone'">
              <a :href="'tel:' + fieldvalue[e.fieldname]">{{fieldvalue[e.fieldname]}}</a>
            </template>
            <template v-else>
{{fieldvalue[e.fieldname]}}
            </template>
            </van-cell>
          </van-cell-group>
        </van-collapse-item>
      </van-collapse>
      <div class="footer_btn">
        <van-button class="backButton" type="info" @click="showTree(2)"
          >返回</van-button
        >
      </div>
    </div>

    <!-- 选择树弹窗 -->
    <PopTree
      ref="addressBook_TreeNode"
      :whichTree="whichTree"
      :module="moduleNo"
      :multiseltree="multiseltree"
      @treeSelectValEvent="treeSelectValEvent"
      @clossTree="clossTree"
    ></PopTree>
  </div>
</template>

<script>
import { Dialog, Toast } from 'vant'
import { getEmpAddressCard } from '@api/workbench.js'
import { parseTime, createGguid } from '@/utils'
import PopTree from '@components/PopTree/index.vue'
export default {
  components: {
    PopTree
  },
  data() {
    const userInfo = localStorage.userInfo
      ? JSON.parse(localStorage.userInfo)
      : {}
    return {
      userInfo,
      loading: false,
      popTreeTag: '',
      multiseltree: false,
      moduleNo: '9916',
      whichTree: 'employee',
      fieldname: 'addressbook',
      empinfo: {},
      fieldlist: [],
      fieldvalue: {},
      activeNames: ['1', '2']
    }
  },
  mounted() {
    this.showTree(1)
  },
  methods: {
    clossTree(){
      this.onClickLeft()
    },
    showTree(type) {
      if(type==1){
         this.$refs.addressBook_TreeNode.module = this.moduleNo
      this.$refs.addressBook_TreeNode.treename = 'emptree'
      this.$refs.addressBook_TreeNode.fieldname = this.fieldname
      this.$refs.addressBook_TreeNode.editstate = 2
      this.$refs.addressBook_TreeNode.showEmpTreePop('通讯录')
      }
      else{
         this.$refs.addressBook_TreeNode.showTreePop = true;
      }
     
    },
    // 选择树回调
    treeSelectValEvent(data) {
      // console.log(data)
      getEmpAddressCard({
        userid: this.userInfo.userid,
        empcode: data.empcode,
        empid: data.empid
      }).then(res => {
        if (res.empinfo.length > 0) {
          this.empinfo = res.empinfo[0]
          this.fieldvalue = res.fieldvalue[0]
          this.fieldlist = res.fieldlist
        }
      })
    },
    // 返回
    onClickLeft() {
      if (this.$route.query.from == 'home') {
        this.$router.push('/home')
      } else {
        this.$router.push('/personCen')
      }
    }
  }
}
</script>

<style lang="less" scoped>
.addressBook_index {
  .van-nav-bar {
    background: #2b8df0;
    /deep/ .van-nav-bar__left {
      .van-icon {
        color: #fff;
      }
    }
    /deep/.van-nav-bar__title {
      color: #fff;
      font-size: 36px;
      font-family: Source Han Sans CN;
    }
    /deep/.van-nav-bar__right {
      font-size: 28px;
      .van-nav-bar__text {
        color: #fff;
      }
    }
  }
  .content {
    margin-top: 1.22667rem;
    margin-bottom: 1.22667rem;
    .van-collapse{
        box-shadow: 0px 0px 20px rgba(0, 0, 0, 0.23);
  background: #ffffff;
  border-radius: 16px;
  margin: 0 30px;
  margin-top:.3rem;
    }
    .personTop {
  // width: 92%;
  box-shadow: 0px 0px 20px rgba(0, 0, 0, 0.23);
  background: #ffffff;
  border-radius: 16px;
  margin: 0 30px;
  margin-top:1.32667rem;

  .personCont {
    padding: 40px 40px 40px 40px;
    display: flex;
  }
}

.presonAvar {
  width: 122px;
  min-width: 122px;
  height: 122px;
  border-radius: 122px;
  border: 2px solid #2b8df0;

  img {
    width: 100%;
    height: 100%;
  }
}

.presonInfo {
  width: 100%;
  height: 122px;
  display: flex;
}

.personCon {
  width: 100%;
  height: 100%;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  padding-left: 15px;

  .personCon_child {
    width: 100%;
  }

  h2 {
    margin: 0;
    font-size: 34px;
    padding: 0;
    line-height: 48px;
    color: #333333;
    width: 100%;
    margin-bottom: 10px;
  }

  p {
    margin: 0;
    padding: 0;
    color: #999999;
    font-size: 24px;
    width: 100%;
  }
}

    .footer_btn {
      width: 100%;
      padding: 0.26667rem 0;
      position: fixed;
      bottom: 0;
      left: 0;
      z-index: 100;
      display: flex;
      background-color: #fff;
      .van-button {
        width: 60%;
        margin: 0 2%;
        border-radius: 9px;
        // width: 3.86667rem;
        .van-button__text {
          font-size: 0.48rem;
          font-family: Source Han Sans CN;
          font-weight: 500;
        }
      }
      .backButton {
        width: 100%;
        height: 90px;
        text-align: center;
        line-height: 90px;
        color: #fff;
        font-size: 36px;
        border-radius: 12px;
      }
    }
  }
}
</style>
